import { render, staticRenderFns } from "./TCVelikContextMenu.vue?vue&type=template&id=2323ea29&"
import script from "./TCVelikContextMenu.vue?vue&type=script&lang=js&"
export * from "./TCVelikContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./TCVelikContextMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports